import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import invariant from "tiny-invariant";
var createContainer = function createContainer() {
  var container = document.createElement("div");
  container.setAttribute("class", "lodestar-portal");
  return container;
};
var getBody = function getBody() {
  invariant(document && document.body, "cannot find document.body");
  return document.body;
};
var getPortalParent = function getPortalParent() {
  var parentElement = document.querySelector("body > .lodestar-portal-container");
  if (!parentElement) {
    var parent = document.createElement("div");
    parent.setAttribute("class", "lodestar-portal-container");
    parent.setAttribute("style", "display: flex;");
    getBody().appendChild(parent);
    return parent;
  }
  return parentElement;
};
export var Portal = function Portal(_ref) {
  var children = _ref.children,
    customContainerElement = _ref.appendTo,
    zIndex = _ref.zIndex;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    container = _useState2[0],
    setContainer = _useState2[1];

  // Choose a container.
  useEffect(function () {
    var newContainer = customContainerElement || createContainer();
    setContainer(newContainer);

    // If we are creating our own portal container element, manage it.
    // Otherwise assume nothing about the provided container element.
    if (!customContainerElement) {
      getPortalParent().appendChild(newContainer);
      return function () {
        // Don't forget to clean up! But there might not be anything
        // to clean up if there was a custom container provided.
        getPortalParent().removeChild(newContainer);
        // clean up parent element if there are no more portals.
        var portals = !!document.querySelector("body > .lodestar-portal-container > .lodestar-portal");
        if (!portals) {
          getBody().removeChild(getPortalParent());
        }
      };
    }
  }, [customContainerElement]);

  // Sync the z-index to the chosen container.
  useEffect(function () {
    if (container) {
      // If we have a custom element, only set the z-index if it's specified, we don't
      // even want to set a z-index of 0 to the custom element if it's not asked for.
      if (customContainerElement && zIndex !== undefined || !customContainerElement) {
        container.style.zIndex = "".concat(zIndex || 0);
      }
    }
  }, [container, zIndex, customContainerElement]);
  return container ? /*#__PURE__*/ReactDOM.createPortal(children, container) : null;
};
//# sourceMappingURL=Portal.js.map